/* eslint no-restricted-syntax: 0, guard-for-in: 0, prefer-destructuring: 0 */
import slugify from 'slugify';
import CirclePacker from 'circlepacker/dist/circlepacker.min';
import * as Utils from '../../utils/utils';
import { gtmBubbles } from '../Seo';

export default class Bubbles {
  constructor() {
    const wrapper = document.querySelector('.product-data-container');

    if (wrapper) {
      this.init();
    }
  }

  /**
   * Init the bubbles only after the user click on the right tab
   */
  init() {
    [].slice.call(document.querySelectorAll('.js-bubbles')).forEach(this.setup);
  }

  setup(node) {
    // Main container element.
    const containerEl = node.querySelector('.js-circles');
    const filters = (window.innerWidth >= 767)
      ? node.querySelector('.js-families-filter')
      : node.querySelector('.js-families-filter-mobile');

    if (!containerEl || !filters) return;

    // Container size
    const bounds = containerEl.getBoundingClientRect();

    // Grab our svg elements from the DOM and store them into an array
    // to use them later in CirclePacker.
    const mySVGs = ['.svg1', '.svg2', '.svg3']
      .map((selector) => node.querySelector(selector));

    // Create an array with our circles.
    const infoCircles = [];
    // References to all circle elements.
    const domCircles = {};

    // Render the svg circles by calculating the sizes and position.
    function onMove(circles) {
      requestAnimationFrame(() => {
        for (const id in circles) {
          const circleEl = domCircles[id];
          const x = circles[id].position.x - circles[id].radius;
          const y = circles[id].position.y - circles[id].radius;

          // Actually move the circles around
          if (circleEl) {
            circleEl.style.transform = `translate(${x}px, ${y}px)`;
            circleEl.classList.add('is-visible');
          }
        }
      });
    }

    //  CirclePacker Instance. Fire up everything
    const packer = new CirclePacker({
      bounds: { width: bounds.width, height: bounds.height },
      target: { x: bounds.width / 2, y: bounds.height / 2 },
      circles: [],
      onMove,
      collisionPasses: 3,
      centeringPasses: 2,
    });

    // Get product datas from our PHP json object and create circles
    // based on those datas inside an array.
    const subFamilies = JSON.parse(containerEl.dataset.bubulles);

    // Adding a bubble and setting up events
    function addBubble(options) {
      const circle = {
        id: (options.id = `circle-${Date.now()}-${slugify(options.title)}`),
        radius: {
          small: window.innerWidth < 767 ? 50 : 70,
          medium: window.innerWidth < 767 ? 70 : 108,
          large: window.innerWidth < 767 ? 85 : 130,
          xlarge: window.innerWidth < 767 ? 100 : 150,
        }[options.size || 'small'],
        position: {
          x: bounds.width / 2 + Math.random(),
          y: bounds.height / 2 + Math.random(),
        },
        family: options.family,
        title: options.title,
        type: options.type,
      };

      // create circle el
      const circleEl = document.createElement('div');
      circleEl.id = circle.id;
      // eslint-disable-next-line
      circleEl.style.width = circleEl.style.height = `${circle.radius * 2}px`;
      circleEl.classList.add('circle', options.color, options.size);

      // Store some datas as attributes.
      circleEl.setAttribute('data-x', circle.position.x);
      circleEl.setAttribute('data-y', circle.position.y);
      circleEl.setAttribute('data-color', options.color);
      circleEl.setAttribute('data-family', options.family);
      circleEl.setAttribute('data-role', options.title);
      circleEl.setAttribute('data-type', options.type);

      // add SVG
      circleEl.appendChild(mySVGs[Utils.randomize(0, mySVGs.length, 1)].cloneNode(true))
        .style.color = options.color;

      // add title
      circleEl
        .appendChild(document.createElement('h3'))
        .appendChild(document.createTextNode(options.title));

      containerEl.appendChild(circleEl);
      domCircles[circle.id] = circleEl;

      // Setup Tabs and events
      const popin = node.querySelector(`.popin[data-title="${options.title}"]`);

      if (popin) {
        popin.setAttribute('data-color', options.color);
        popin.style.color = options.color;
      }

      // Set bgcolor on the tab element selected by default
      const defaultSelected = node.querySelector(`.popin[data-title="${options.title}"] .pr-selected`);

      if (defaultSelected) {
        node.querySelector(`.popin[data-title="${options.title}"] .pr-selected`)
          .style.backgroundColor = options.color;
      }

      // Set the bullet background color inside the breadcrumb
      const popinDot = popin.querySelector('.dot');

      if (popinDot) {
        popinDot.style.background = options.color;
      }

      // Open the default popin.
      circleEl.addEventListener('click', () => {
        popin.classList.toggle('open', true);
        document.querySelector('body').classList.toggle('overlay-open', true);

        // Send the GTM event when clicking on a bubble.
        gtmBubbles(circleEl.dataset.type, circleEl.dataset.role);
      });

      // Close the default popin.
      [...popin.querySelectorAll('.js-btn-close')].forEach((element) => {
        element.addEventListener('click', () => {
          popin.classList.toggle('open', false);
          document.querySelector('body').classList.toggle('overlay-open', false);
        });
      });

      packer.addCircle(circle);
    }

    // Removing a bubble
    function removeBubble(circle) {
      const id = circle.id;

      packer.removeCircle(domCircles[id]);

      requestAnimationFrame(() => containerEl
        .removeChild(domCircles[id]) && delete domCircles[id]);
    }

    /**
     * For each ingredient/patent/whatever, create a circle and add some datas
     * if needed like the color, the size,...
     */
    for (const title in subFamilies) {
      // Get the colors from the families filter at the top of the dataviz
      const firstItem = subFamilies[title][0];
      const family = firstItem.role_famille;
      const color = filters.querySelector(`[data-family="${family}"]`).dataset.color;
      const importance = firstItem.importance;
      const size = {
        Gamme: 'large',
        Produit: 'xlarge',
        Marque: 'medium',
      }[importance] || 'small';

      let type;

      if (firstItem.bre_extid) {
        type = 'brevet';
      } else {
        type = 'ingredient';
      }

      const circle = { size, color, title, family, type };

      infoCircles.push(circle);
      addBubble(circle);
    }

    // Switching categories
    if (window.innerWidth >= 767) {
      const inputs = [].slice.call(filters.querySelectorAll('input'));
      inputs.forEach((checkbox) => {
        checkbox.addEventListener('change', () => {
          infoCircles.forEach(
            (circle) => circle.family === checkbox.dataset.familyRaw
              && (checkbox.checked ? addBubble(circle) : removeBubble(circle)),
          );
        });
      });
    } else {
      const select = filters.querySelector('select');
      select.addEventListener('change', () => {
        infoCircles.forEach((circle) => {
          if (domCircles[circle.id]) removeBubble(circle);
          if (circle.family === select.value) {
            addBubble(circle);
          }
          if (select.value === 'all-family') addBubble(circle);
        });
      });
    }
  }
}
